import { Bot, X } from "lucide-react-native";
import { FC, useState } from "react";
import { Modal, Pressable } from "react-native";

import { StudyChat } from "@/components/studies";
import { Box, Button, ButtonIcon, HStack, Text, VStack } from "@/components/ui";
import { useLocalization } from "@/hooks";

interface StudyChatButtonProps {
  runId: string;
  studyId: string;
}

const StudyChatButton: FC<StudyChatButtonProps> = ({ runId, studyId }) => {
  const { i18n } = useLocalization();
  const [showChat, setShowChat] = useState(false);

  return (
    <>
      <Pressable
        className="absolute bottom-4 right-4 w-16 h-16 rounded-full bg-primary-500 shadow-lg z-50 items-center justify-center"
        onPress={() => setShowChat(true)}
      >
        <Bot className="text-white" size={32} />
      </Pressable>

      {showChat && (
        <Modal
          animationType="fade"
          onRequestClose={() => setShowChat(false)}
          transparent={true}
          visible={showChat}
        >
          {/* Overlay */}
          <Pressable
            className="absolute inset-0 bg-black/50"
            onPress={() => setShowChat(false)}
          />
          <Box
            className="absolute bottom-4 right-4 w-[450px] bg-white dark:bg-background-900 shadow-2xl rounded-2xl overflow-hidden"
            style={{ maxWidth: "90%", height: 600, maxHeight: "80%" }}
          >
            <VStack className="flex-1">
              {/* Header */}
              <HStack className="p-4 border-b border-outline-200 dark:border-outline-700 bg-white dark:bg-background-900 items-center justify-between">
                <Text className="text-base font-semibold text-typography-900 dark:text-typography-100">
                  {i18n.t("studies.studyChat")}
                </Text>
                <Button onPress={() => setShowChat(false)} variant="link">
                  <ButtonIcon
                    as={X}
                    className="text-typography-600 dark:text-typography-400"
                  />
                </Button>
              </HStack>

              {/* Content */}
              <Box className="flex-1 bg-background-50 dark:bg-background-950">
                <StudyChat runId={runId} studyId={studyId} />
              </Box>
            </VStack>
          </Box>
        </Modal>
      )}
    </>
  );
};

export default StudyChatButton;
